var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('ModelCreaterStyled', [_c('div', {
    staticClass: "title"
  }, [_vm.showPrevArrow ? _c('button', {
    on: {
      "click": _vm.goBack
    }
  }, [_c('ArrowLeftIcon')], 1) : _vm._e(), _vm._v(" " + _vm._s(_vm.title) + " ")]), _c('div', {
    staticClass: "main"
  }, [_vm._t("default"), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_vm.loading ? _c('LoadingOverlayStyled', [_c('TalpaLoaderWrapper')], 1) : _vm._e()], 1)], 2), _c('div', {
    staticClass: "footer"
  }, [_c('button', {
    attrs: {
      "disabled": !_vm.canCreate
    },
    on: {
      "click": function click($event) {
        return _vm.$emit('create');
      }
    }
  }, [_c('CheckIcon'), _vm._v(" " + _vm._s(_vm.createLabel))], 1), _c('button', {
    attrs: {
      "disabled": !_vm.canCancel
    },
    on: {
      "click": function click($event) {
        return _vm.$emit('cancel');
      }
    }
  }, [_c('XIcon'), _vm._v(" cancel")], 1), _vm.hasErrors ? _c('AlertTriangleIcon') : _vm._e()], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }